// extracted by mini-css-extract-plugin
module.exports = {"container":"CardPanel-module__container___3gmXE","panel":"CardPanel-module__panel___2fXBe","responsivePadding":"CardPanel-module__responsivePadding___V81b6"};